export var BillNotificationType;
(function (BillNotificationType) {
    // To the owner
    BillNotificationType["FriendReviewed"] = "FRIEND_REVIEWED";
    BillNotificationType["FriendFlagged"] = "FRIEND_FLAGGED";
    BillNotificationType["ReadyToFinalize"] = "READY_TO_FINALIZE";
    BillNotificationType["SlipNeedsDecision"] = "SLIP_NEEDS_DECISION";
    BillNotificationType["FriendPaid"] = "FRIEND_PAID";
    // To a friend
    BillNotificationType["BillFinalized"] = "BILL_FINALIZED";
    BillNotificationType["AmountChanged"] = "AMOUNT_CHANGED";
    BillNotificationType["FlagResolved"] = "FLAG_RESOLVED";
    BillNotificationType["SlipConfirmed"] = "SLIP_CONFIRMED";
    BillNotificationType["SlipRejected"] = "SLIP_REJECTED";
})(BillNotificationType || (BillNotificationType = {}));
//# sourceMappingURL=bill-notification-type.enum.js.map